/* Sui Story — product page behaviour: option pills (proxy a hidden <select>),
   quantity stepper, gallery thumbs, AJAX add-to-cart (via SuiStory.cart),
   application-guide modal, and the mobile sticky ATC.
   Re-inits per Barba container on 'suistory:page:init'. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});
  var addingNow = false;

  function addToCart(form, atc, atcText) {
    if (addingNow) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var qtyInput = form.querySelector('[data-qty-input]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    addingNow = true;
    if (atc) { atc.disabled = true; atc.classList.add('is-loading'); atc.classList.remove('is-added'); }
    if (atcText) atcText.textContent = 'Adding…';
    var reset = function () {
      addingNow = false;
      if (atc) { atc.disabled = false; atc.classList.remove('is-loading'); }
      if (atcText) atcText.textContent = 'Add to Bag';
    };
    var success = function () {
      addingNow = false;
      if (atc) { atc.classList.remove('is-loading'); atc.classList.add('is-added'); }
      if (atcText) atcText.textContent = 'Added';
      var announce = document.querySelector('[data-atc-announce]');
      if (announce) announce.textContent = 'Added to bag';
      if (navigator.vibrate) { try { navigator.vibrate(10); } catch (e) {} }
      setTimeout(function () {
        if (atc) { atc.classList.remove('is-added'); atc.disabled = false; }
        if (atcText) atcText.textContent = 'Add to Bag';
      }, 1600);
    };
    if (S.cart && S.cart.add) {
      S.cart.add(idInput.value, qty).then(success).catch(reset);
    } else {
      form.submit();
    }
  }

  function initProduct(scope) {
    var section = (scope || document).querySelector('[data-product-section]');
    if (!section || section.dataset.pfInit) return;
    section.dataset.pfInit = '1';

    var form = section.querySelector('.product-form');
    var select = section.querySelector('[data-variant-select]');
    var priceEl = section.querySelector('[data-price]');
    var atc = section.querySelector('[data-atc]');
    var atcText = section.querySelector('[data-atc-text]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (opt.dataset.price) {
          if (priceEl) priceEl.textContent = opt.dataset.price;
          if (stickyPrice) stickyPrice.textContent = opt.dataset.price;
        }
        if (atc) {
          atc.disabled = opt.disabled;
          if (atcText) atcText.textContent = opt.disabled ? 'Sold Out' : 'Add to Bag';
        }
      });
    }

    // Option pills proxy the hidden <select>
    var pills = section.querySelectorAll('[data-variant-pill]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (!select || pill.classList.contains('is-unavailable')) return;
        select.value = pill.getAttribute('data-variant-id');
        select.dispatchEvent(new Event('change'));
        pills.forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    });

    // Quantity stepper
    var qtyWrap = section.querySelector('[data-qty]');
    if (qtyWrap) {
      var qInput = qtyWrap.querySelector('[data-qty-input]');
      qtyWrap.addEventListener('click', function (e) {
        if (!qInput) return;
        var v = parseInt(qInput.value, 10) || 1;
        if (e.target.closest('[data-qty-up]')) qInput.value = v + 1;
        if (e.target.closest('[data-qty-down]')) qInput.value = Math.max(1, v - 1);
      });
      if (qInput) qInput.addEventListener('input', function () { qInput.value = qInput.value.replace(/[^0-9]/g, ''); });
    }

    // Gallery — single main frame; thumbnail clicks + one-image-per-swipe change the active image
    var gallery = section.querySelector('[data-product-gallery]');
    var thumbsWrap = section.querySelector('[data-product-thumbs]');
    var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]')) : [];
    var thumbBtns = Array.prototype.slice.call(section.querySelectorAll('[data-thumb]'));

    function galleryActiveIndex() {
      for (var gi = 0; gi < slides.length; gi++) { if (slides[gi].classList.contains('is-active')) return gi; }
      return 0;
    }
    function gallerySetActive(idx) {
      if (idx < 0 || idx >= slides.length) return;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      thumbBtns.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
      var th = thumbBtns[idx];
      if (thumbsWrap && th) {
        var twRect = thumbsWrap.getBoundingClientRect(), thRect = th.getBoundingClientRect();
        var target = thumbsWrap.scrollLeft + (thRect.left - twRect.left) - (thumbsWrap.clientWidth - thRect.width) / 2;
        thumbsWrap.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
    thumbBtns.forEach(function (btn, i) { btn.addEventListener('click', function () { gallerySetActive(i); }); });

    // One horizontal swipe on the main frame advances exactly one image
    if (gallery && slides.length > 1) {
      var sx = null, sy = null;
      gallery.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          gallerySetActive(galleryActiveIndex() + (dx < 0 ? 1 : -1));
        }
        sx = null; sy = null;
      }, { passive: true });
    }

    // Blur-up: drop the LQIP blur once each gallery image has loaded
    var blurImgs = section.querySelectorAll('.product__media-img.is-blurup');
    blurImgs.forEach(function (img) {
      if (img.complete && img.naturalWidth) { img.classList.remove('is-blurup'); }
      else { img.addEventListener('load', function () { img.classList.remove('is-blurup'); }, { once: true }); }
    });

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form, atc, atcText); });
    }

    // Sticky ATC appears the moment the main Add-to-Bag button scrolls above the viewport top
    var sticky = document.querySelector('[data-sticky-atc]');
    var stickyAdd = document.querySelector('[data-sticky-add]');
    var waFloat = document.querySelector('.whatsapp-float');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var pastTop = !en.isIntersecting && en.boundingClientRect.top < 0;
        if (pastTop) { sticky.removeAttribute('hidden'); if (waFloat) waFloat.classList.add('is-raised'); }
        else { sticky.setAttribute('hidden', ''); if (waFloat) waFloat.classList.remove('is-raised'); }
      }, { threshold: 0 });
      io.observe(atc);
    }
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () { addToCart(form, atc, atcText); });
    }
  }

  // Application-guide modal — one delegated listener for the whole document
  document.addEventListener('click', function (e) {
    var ag = document.getElementById('AppGuide');
    if (!ag) return;
    if (e.target.closest('[data-appguide-open]')) { e.preventDefault(); if (ag.showModal) ag.showModal(); }
    else if (e.target.closest('[data-appguide-close]') || e.target === ag) { if (ag.close) ag.close(); }
  });

  document.addEventListener('suistory:page:init', function (e) {
    var wa = document.querySelector('.whatsapp-float'); if (wa) wa.classList.remove('is-raised');
    initProduct(e.detail && e.detail.scope);
  });
  if (document.readyState !== 'loading') initProduct(document);
  else document.addEventListener('DOMContentLoaded', function () { initProduct(document); });
})();
